
import { Component, Prop, Vue } from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import { ClientsStore } from "@/store/modules/Clients";
import {WorkersStore} from "@/store/modules/Workers";

import { IClients } from "@/entity/clients/clients.types";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";

import VisitGeneralForm from "@/form/visits/visitGeneral";
import VisitCreateForm from "@/form/visits/visitCreate";

import {ServiceStore} from "@/store/modules/Services";
import {IServices, IServicesListItem} from "@/entity/services/services.types";

import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import { IServicesCategory, IServicesCategoryListItem } from "@/entity/servicesCategory/services.category.types";

import VisitServiceMulty from "@/UI/components/forms/visits/create/VisitServiceMulty.vue";
import {message} from "ant-design-vue";
import { checkUserRole, getUserData } from '@/router/Lib/helper';
import { mixins } from "vue-class-component";
import { ProxyDataForm } from "@/UI/components/Helpers/ProxyDataForm";
import { SourcesStore } from '@/store/modules/Sources';
import { ISources } from '@/entity/sources/sources.types';

import moment from 'moment';


@Component({
    components: { FormGroup, VisitServiceMulty},
    methods: { moment }
})
export default class VisitCreateDetailMain extends mixins(
        ProxyDataForm,
    ) {
    @Prop() form!:  VisitCreateForm;
    
    cosmetologist_fio: any | undefined;
    select_salon_id: number | null = null;
    clients_arr: any | null = null;
    clients_input_data_source: Map<any,any>;
    clients_input_phone_data: any[] | undefined = [];
    client_id: number | null = null;

    constructor() {
        super();
        this.clients_input_data_source = new Map();
    }

        searchByPhone(value:any){
            this.form.setFormData(this.clients?.data.find(e=> e.phone == value));
            console.log('phone ->');
            console.log(value);
        }

        search_clients(value:any){

        }

        newClient(){
            this.form = new VisitCreateForm();
        }

        selectClient(value:any){
            console.clear();
            console.log("value -> ");
            console.log(value);
            // console.log(this.form.client_id);
            console.log("client name -> ");
            console.log(this.form.client_name );
            console.log(typeof this.form.client_name );

            // let client = this.clients?.data.find(e=> e.name == this.form.client_name);
            // console.log('client');

            // console.log(client);

            // if(client && client !== undefined){
            //     console.log(typeof value);
            //     this.form.client_id          = client.id;
            //     this.form.client_source      = client.source;
            //     this.form.client_name        = client.name;
            //     this.form.client_phone       = client.phone;
            //     this.form.client_email       = client.email;
            //     this.form.memberships_info   = client.memberships_info;
            //     this.form.certificates_info  = client.certificates_info;
            //     this.form.paid               = client.paid;
            //     this.form.sold               = client.sold;
            //     this.form.new_client         = false;

            //     if(this.form.client_visit_info.visit_last_date )
            //         this.form.client_visit_info.visit_last_date  = client.client_visit_info.visit_last_date;
                
            //     if(this.form.client_visit_info.count_visits )
            //         this.form.client_visit_info.count_visits     = client.client_visit_info.count_visits;
            // }else{
            //     console.log('in there');
            //     this.form.client_name        = value;
            //     this.form.client_id          = null;
            //     this.form.client_email       = null;
            //     this.form.memberships_info   = null;
            //     this.form.certificates_info  = null;
            //     this.form.paid               = null;
            //     this.form.sold               = null;
            //     this.form.new_client         = true;
            //     this.form.client_visit_info.count_visits = 0;
            //     this.form.client_visit_info.visit_last_date  = '';
            // }

            // console.log('after client');
            // console.log(this.form.client_name);
            // console.log(this.form);
            // console.log(this.form.client_phone);
        }

        selectPhone(value:any){
            console.clear();
            console.log(value);
            console.log(typeof value);

            let client = this.clients?.data.find(e=> e.phone == value);

            if(client && client !== undefined){
                console.log(typeof value);
                this.form.client_id          = client.id;
                this.form.client_name        = client.name;
                //this.form.client_source      = client.source;
                this.form.client_phone       = client.phone;
                this.form.client_email       = client.email;
                this.form.memberships_info   = client.memberships_info;
                this.form.certificates_info  = client.certificates_info;
                this.form.paid               = client.paid;
                this.form.sold               = client.sold;
                this.form.new_client         = false;

                if(this.form.client_visit_info.visit_last_date )
                    this.form.client_visit_info.visit_last_date  = client.visit_last_date;
                
                if(this.form.client_visit_info.count_visits )
                    this.form.client_visit_info.count_visits     = client.count_all_visits;
            }else{
                this.form.client_phone       = value;
                this.form.client_id          = null;
                this.form.client_email       = null;
                this.form.memberships_info   = null;
                this.form.certificates_info  = null;
                this.form.paid               = null;
                this.form.sold               = null;
                this.form.new_client         = true;
                this.form.client_visit_info.count_visits = 0;
                this.form.client_visit_info.visit_last_date  = '';
            }

            console.log('after phone');
            console.log(this.form.client_name);
            console.log(this.form.client_source);
            console.log(this.form.client_phone);
        }

        handleTimeDate(time: any) {
            this.form.visit_date = time.format('YYYY-MM-DD');
        }

        handleTimeDateTime(time: any) {
            this.form.visit_date_time = time.format('HH:mm');
            this.form.visit_date_time_start = time.format('HH:mm');
            this.handleDiffTime(this.form.visit_date_time_end, this.form.visit_date_time_start);
        }

        handleTimeEndToDateTime(time:any){
            this.form.visit_date_time_end = time.format('HH:mm');
            this.handleDiffTime(time, this.form.visit_date_time_start);
        }

        handleDiffTime(time_end: any, time_start: any){

            let diff = moment.utc(moment(time_end).diff(moment(time_start, 'HH:mm'))).format('HH:mm');
            this.form.visit_duration = diff;
        }

        handleTimeDuration(time: any) {
            this.form.visit_duration = time.format('HH:mm');
        }
 
        setStatus(key:any){
            this.form.status_id = key;
        }

        handleTimeChange(value: any): void {
            this.form.visit_duration = value.format('HH:mm');
        }
        
        get service(): IServices | null {
            return ServiceStore.service;
        }

        get servicesCategory(): IServicesCategory | null {
            return ServicesCategoryStore.serviceCategory;
        }

        get clients(): IClients | null {
            return ClientsStore.clients;
        }

        get staff(): IWorkers | null {
          return WorkersStore.workers;
        }

        get sourceArray(): ISources[] {
            return SourcesStore.sources;
        }
        
        async created(): Promise<void> {
            await SourcesStore.fetchAll();
            const Role = checkUserRole();
            const UserData = getUserData();
            for(let i = 0; i < this.clients!?.data.length; i++){
                this.clients_input_data_source!.set(this.clients?.data[i].id, this.clients?.data[i].name);
                this.clients_input_phone_data!.push(this.clients?.data[i].phone);
            }
            this.clients_arr = ClientsStore.clients?.data;
            // console.clear();
            console.log('clients');
            console.log(this.clients_input_data_source);
            // await ServicesCategoryStore.fetchAll({limit: 20});
            await ServiceStore.fetchAll({limit: 50, filter: {salon_id: this.$store.state.salon_id}});
            this.cosmetologist_fio = WorkersStore.workers?.data.find(el => el.id == this.form.cosmetologists_id)!.fio ?? 0;
            console.log(this.cosmetologist_fio);
        }
}
